export default {
    name: "GetData",
    title: "Get Data",
    icon: "mdi-database-export",
    create() {
        return {
            name: this.title,
            description: "",
            actionType: this.name,
            childAction1: [],
            childAction2: [],
            parameter1: null,
            parameter2: null,
            parameter3: null,
            parameter4: null,
            parameter5: null,
            filters: [],
            values: [],
            columns: [],
        };
    },
};